import { render, staticRenderFns } from "./ProjectSummaryActive.vue?vue&type=template&id=0f954707"
import script from "./ProjectSummaryActive.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports